module.exports = __webpack_public_path__ + "static/media/icon-request-call.74a9aa46.svg";